import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard, Truck, MapPin, Check, Lock, ArrowLeft } from 'lucide-react';
import Header from './components/Header2';
import Footer from './components/Footer2';
import Button from './components/Button';

const Checkout = () => {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState({
        fullName: '', email: '', phone: '', address: '', city: '', state: '', pincode: '',
        paymentMethod: 'card', cardNumber: '', cardExpiry: '', cardCvv: '',
    });

    const steps = [
        { num: 1, label: 'Shipping', icon: MapPin },
        { num: 2, label: 'Payment', icon: CreditCard },
        { num: 3, label: 'Confirm', icon: Check },
    ];

    const orderItems = [
        { name: 'Royal Banarasi Saree', size: 'Free Size', qty: 1, price: 12999, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=200' },
        { name: 'Designer Anarkali Kurta', size: 'M', qty: 2, price: 8999, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=200' },
    ];

    const subtotal = orderItems.reduce((sum, i) => sum + i.price * i.qty, 0);
    const shipping = 0;
    const total = subtotal + shipping;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const inputClass = "w-full px-4 py-3 text-sm bg-[#1A1A1A] border border-[#2A2A2A] text-white placeholder-[#525252] focus:outline-none focus:border-[#FF6B35] transition-colors font-['Montserrat']";
    const labelClass = "block text-xs font-semibold text-[#A3A3A3] uppercase tracking-wider mb-2 font-['Montserrat']";

    return (
        <div className="w-full min-h-screen bg-[#0A0A0A]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap" rel="stylesheet" />
            <Header />

            <main className="pt-[90px] md:pt-[110px] pb-16">
                <div className="max-w-[1000px] mx-auto px-4 md:px-6">
                    {/* Back */}
                    <button
                        onClick={() => navigate('/template2/cart')}
                        className="inline-flex items-center gap-2 text-xs text-[#A3A3A3] hover:text-[#FF6B35] transition-colors mb-6 font-['Montserrat'] uppercase tracking-wider"
                    >
                        <ArrowLeft className="w-4 h-4" /> Back to Cart
                    </button>

                    <h1 className="text-2xl md:text-3xl font-bold text-white mb-8 font-['Montserrat'] uppercase">
                        Checkout
                    </h1>

                    {/* Steps */}
                    <div className="flex items-center justify-center gap-4 md:gap-8 mb-10">
                        {steps.map((step, i) => (
                            <React.Fragment key={step.num}>
                                <div className="flex items-center gap-2">
                                    <div className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center text-xs font-bold font-['Montserrat'] ${
                                        currentStep >= step.num ? 'bg-[#FF6B35] text-white' : 'bg-[#1A1A1A] text-[#525252] border border-[#2A2A2A]'
                                    }`}>
                                        {currentStep > step.num ? <Check className="w-4 h-4" /> : step.num}
                                    </div>
                                    <span className={`text-xs font-medium hidden md:block font-['Montserrat'] uppercase tracking-wider ${
                                        currentStep >= step.num ? 'text-[#FF6B35]' : 'text-[#525252]'
                                    }`}>
                                        {step.label}
                                    </span>
                                </div>
                                {i < steps.length - 1 && (
                                    <div className={`flex-1 h-px max-w-[60px] md:max-w-[100px] ${currentStep > step.num ? 'bg-[#FF6B35]' : 'bg-[#2A2A2A]'}`} />
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                        {/* Form */}
                        <div className="lg:col-span-2">
                            {currentStep === 1 && (
                                <div className="bg-[#1A1A1A] border border-[#2A2A2A] p-6">
                                    <h2 className="text-base font-bold text-white mb-6 font-['Montserrat'] uppercase tracking-wider">Shipping Details</h2>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="md:col-span-2">
                                            <label className={labelClass}>Full Name</label>
                                            <input name="fullName" value={formData.fullName} onChange={handleChange} placeholder="Your full name" className={inputClass} />
                                        </div>
                                        <div>
                                            <label className={labelClass}>Email</label>
                                            <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="you@email.com" className={inputClass} />
                                        </div>
                                        <div>
                                            <label className={labelClass}>Phone</label>
                                            <input name="phone" value={formData.phone} onChange={handleChange} placeholder="+91 98765 43210" className={inputClass} />
                                        </div>
                                        <div className="md:col-span-2">
                                            <label className={labelClass}>Address</label>
                                            <input name="address" value={formData.address} onChange={handleChange} placeholder="Street address" className={inputClass} />
                                        </div>
                                        <div>
                                            <label className={labelClass}>City</label>
                                            <input name="city" value={formData.city} onChange={handleChange} placeholder="City" className={inputClass} />
                                        </div>
                                        <div>
                                            <label className={labelClass}>State</label>
                                            <input name="state" value={formData.state} onChange={handleChange} placeholder="State" className={inputClass} />
                                        </div>
                                        <div>
                                            <label className={labelClass}>Pincode</label>
                                            <input name="pincode" value={formData.pincode} onChange={handleChange} placeholder="400001" className={inputClass} />
                                        </div>
                                    </div>
                                    <Button variant="primary" size="lg" fullWidth className="mt-6" onClick={() => setCurrentStep(2)}>
                                        Continue to Payment
                                    </Button>
                                </div>
                            )}

                            {currentStep === 2 && (
                                <div className="bg-[#1A1A1A] border border-[#2A2A2A] p-6">
                                    <h2 className="text-base font-bold text-white mb-6 font-['Montserrat'] uppercase tracking-wider">Payment Method</h2>
                                    <div className="space-y-3 mb-6">
                                        {['card', 'upi', 'cod'].map((method) => (
                                            <label
                                                key={method}
                                                className={`flex items-center gap-3 p-4 border cursor-pointer transition-colors ${
                                                    formData.paymentMethod === method ? 'border-[#FF6B35] bg-[#FF6B35]/5' : 'border-[#2A2A2A] hover:border-[#FF6B35]/50'
                                                }`}
                                            >
                                                <input
                                                    type="radio"
                                                    name="paymentMethod"
                                                    value={method}
                                                    checked={formData.paymentMethod === method}
                                                    onChange={handleChange}
                                                    className="accent-[#FF6B35]"
                                                />
                                                <span className="text-sm text-white font-medium font-['Montserrat'] capitalize">
                                                    {method === 'card' ? 'Credit / Debit Card' : method === 'upi' ? 'UPI Payment' : 'Cash on Delivery'}
                                                </span>
                                            </label>
                                        ))}
                                    </div>

                                    {formData.paymentMethod === 'card' && (
                                        <div className="space-y-4 mb-6">
                                            <div>
                                                <label className={labelClass}>Card Number</label>
                                                <input name="cardNumber" value={formData.cardNumber} onChange={handleChange} placeholder="1234 5678 9012 3456" className={inputClass} />
                                            </div>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                    <label className={labelClass}>Expiry</label>
                                                    <input name="cardExpiry" value={formData.cardExpiry} onChange={handleChange} placeholder="MM/YY" className={inputClass} />
                                                </div>
                                                <div>
                                                    <label className={labelClass}>CVV</label>
                                                    <input name="cardCvv" value={formData.cardCvv} onChange={handleChange} placeholder="123" className={inputClass} />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="flex gap-3">
                                        <Button variant="ghost" size="lg" onClick={() => setCurrentStep(1)}>Back</Button>
                                        <Button variant="primary" size="lg" className="flex-1" onClick={() => setCurrentStep(3)}>Review Order</Button>
                                    </div>
                                </div>
                            )}

                            {currentStep === 3 && (
                                <div className="bg-[#1A1A1A] border border-[#2A2A2A] p-6">
                                    <h2 className="text-base font-bold text-white mb-6 font-['Montserrat'] uppercase tracking-wider">Order Review</h2>
                                    <div className="space-y-4 mb-6">
                                        {orderItems.map((item, i) => (
                                            <div key={i} className="flex gap-3 pb-4 border-b border-[#2A2A2A] last:border-0">
                                                <img src={item.image} alt={item.name} className="w-16 h-20 object-cover" />
                                                <div className="flex-1">
                                                    <h3 className="text-sm font-medium text-white font-['Montserrat']">{item.name}</h3>
                                                    <p className="text-xs text-[#525252] font-['Montserrat']">Size: {item.size} | Qty: {item.qty}</p>
                                                    <p className="text-sm font-bold text-[#FF6B35] mt-1 font-['Montserrat']">{'\u20B9'}{(item.price * item.qty).toLocaleString('en-IN')}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="border-t border-[#2A2A2A] pt-4 mb-6">
                                        <p className="text-xs text-[#A3A3A3] mb-1 font-['Montserrat']"><strong className="text-white">Shipping to:</strong> {formData.fullName}, {formData.address}, {formData.city}</p>
                                        <p className="text-xs text-[#A3A3A3] font-['Montserrat']"><strong className="text-white">Payment:</strong> {formData.paymentMethod === 'card' ? 'Card' : formData.paymentMethod === 'upi' ? 'UPI' : 'Cash on Delivery'}</p>
                                    </div>
                                    <div className="flex gap-3">
                                        <Button variant="ghost" size="lg" onClick={() => setCurrentStep(2)}>Back</Button>
                                        <Button variant="primary" size="lg" className="flex-1 gap-2">
                                            <Lock className="w-4 h-4" /> Place Order - {'\u20B9'}{total.toLocaleString('en-IN')}
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Order Summary Sidebar */}
                        <div className="bg-[#1A1A1A] border border-[#2A2A2A] p-6 h-fit">
                            <h3 className="text-sm font-bold text-white mb-4 font-['Montserrat'] uppercase tracking-wider">Summary</h3>
                            <div className="space-y-2 text-sm font-['Montserrat']">
                                {orderItems.map((item, i) => (
                                    <div key={i} className="flex justify-between text-[#A3A3A3]">
                                        <span className="truncate mr-2">{item.name} x{item.qty}</span>
                                        <span className="text-white flex-shrink-0">{'\u20B9'}{(item.price * item.qty).toLocaleString('en-IN')}</span>
                                    </div>
                                ))}
                                <div className="flex justify-between text-[#A3A3A3] border-t border-[#2A2A2A] pt-2">
                                    <span>Shipping</span>
                                    <span className="text-white">{shipping === 0 ? 'Free' : `\u20B9${shipping}`}</span>
                                </div>
                                <div className="flex justify-between font-bold border-t border-[#2A2A2A] pt-2">
                                    <span className="text-white">Total</span>
                                    <span className="text-[#FF6B35]">{'\u20B9'}{total.toLocaleString('en-IN')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Checkout;
